module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("Gb6vs"))).then(() => parcelRequire('hEqeo'));